var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ws-spinner"},[_c(_vm.currentSpinner,_vm._b({tag:"component",attrs:{"width":_vm.getSpinnerDefaultSize,"height":_vm.height,"color":_vm.getSpinnerColor}},'component',_vm.$attrs,false)),(_vm.text)?_c('span',{staticClass:"text q-ml-md"},[_vm._v(_vm._s(_vm.$t(_vm.text)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }